import React from "react";

/**
 * Editorial split: sticky title + supporting content on the right.
 * Uses the new hairline-separated section rhythm; no panels.
 */
export function TwoCol({ label, title, lede, children, id, hairline = true }) {
  return (
    <section className={`mkt-shell${hairline ? " mkt-section" : ""}`} data-testid={id}>
      <div className="mkt-split" style={{ padding: 0 }}>
        <div className="mkt-split-title-col">
          {label && <div className="mkt-label mkt-split-label">{label}</div>}
          <h2 className="mkt-h-l">{title}</h2>
          {lede && <p className="mkt-body mkt-body-lg mkt-split-lede">{lede}</p>}
        </div>
        <div>{children}</div>
      </div>
    </section>
  );
}
